if (!customElements.get('cavador-studio-comparison')) {
  customElements.define('cavador-studio-comparison', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      const range = this.querySelector('input[type="range"]');
      if (!range) return;
      this.dataset.ready = 'true';
      const originalLabel = this.querySelector('.cavador-studio-showcase__label--before');
      const previewLabel = this.querySelector('.cavador-studio-showcase__label--after');
      const update = () => {
        const value = Math.max(0, Math.min(100, Number(range.value)));
        this.style.setProperty('--reveal', `${value}%`);
        range.setAttribute('aria-valuetext', (this.dataset.valueTemplate || '[percent]%').replace('[percent]', String(value)));
        if (originalLabel) originalLabel.style.visibility = value < 18 ? 'hidden' : 'visible';
        if (previewLabel) previewLabel.style.visibility = value > 82 ? 'hidden' : 'visible';
      };
      range.addEventListener('input', update);
      update();
    }
  });
}

if (!customElements.get('cavador-studio-return')) {
  customElements.define('cavador-studio-return', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      const link = this.querySelector('a[href="#CavadorWallStudio"]');
      if (!link) return;
      this.dataset.ready = 'true';
      link.addEventListener('click', event => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const studio = document.getElementById('CavadorWallStudio');
        if (!studio) return;
        event.preventDefault();
        event.stopPropagation();
        studio.setAttribute('tabindex', '-1');
        studio.focus({ preventScroll: true });
        studio.scrollIntoView({
          block: 'start',
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
      });
    }
  });
}